import api from '../common/api/reportingApi';

const basePath = '/report/account';
const baseAccountsPath = '/report/getallaccounts';
const baseBillingOfAccountPath = '/report/getbilling';
const domainsBasePath = '/report/domains';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },

  getAccounts(params = {}) {
    return api.get(baseAccountsPath, { params });
  },

  getBillingOfAccount(filters, params = {}) {
    return api.get(`${baseBillingOfAccountPath}/${filters.accountId}/${filters.month}/${filters.year}`, { params });
  },

  domainsReport(params = { }) {
    return api.get(domainsBasePath, { params });
  }
};




// WEBPACK FOOTER //
// ./src/services/reportService.js